module.exports = "/_next/static/images/CaliforniaLogo-ecffa5295ca00c4a4e22761c2c69161e.png";